/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeleteFileRequest = {
  fileId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const DeleteFileRequest$inboundSchema: z.ZodType<
  DeleteFileRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  file_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "file_id": "fileId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type DeleteFileRequest$Outbound = {
  file_id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const DeleteFileRequest$outboundSchema: z.ZodType<
  DeleteFileRequest$Outbound,
  z.ZodTypeDef,
  DeleteFileRequest
> = z.object({
  fileId: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    fileId: "file_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function deleteFileRequestToJSON(
  deleteFileRequest: DeleteFileRequest,
): string {
  return JSON.stringify(
    DeleteFileRequest$outboundSchema.parse(deleteFileRequest),
  );
}
export function deleteFileRequestFromJSON(
  jsonString: string,
): SafeParseResult<DeleteFileRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeleteFileRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteFileRequest' from JSON`,
  );
}
